import React, {Fragment} from "react";
import StepHeader from "../StepHeader";
import ReadOnlyField from "../../ReadOnlyField";
import EvidenceList from "../../components/EvidenceList";

export default class EvidenceSupport extends React.Component {

    constructor(props) {
        super(props);
        this.identifier = "evidencesupport";
    }

    render() {
        return (
            <Fragment>
                <StepHeader section={this.props.section} tooltipTitle={true} />
                <h2>Claim</h2>
                <ReadOnlyField identifier="claim" className="box bg-autofill" />
                <EvidenceList doc={this.props.doc} identifier="evidencesupport" canBeEmpty={false} data={this.props.data} hLevel={2} hClassName="h3"/>
            </Fragment>
        );
    }

}
